import { useState } from 'react';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router';
import { AuthProvider } from './features/auth/auth-context';
import { createQueryClient } from './lib/query-client';
import { router } from './router';

/**
 * Provider order matters:
 *  - QueryClientProvider wraps everything that fetches.
 *  - AuthProvider wraps the router (routes read auth state).
 *  - RouterProvider is the leaf.
 *
 * QueryClient is created via lazy useState so we get one instance per
 * app mount even under StrictMode's double-invoke (Vercel rule
 * `rerender-lazy-state-init`).
 */
export function App() {
  const [queryClient] = useState(() => createQueryClient());

  return (
    <QueryClientProvider client={queryClient}>
      <AuthProvider>
        <RouterProvider router={router} />
      </AuthProvider>
    </QueryClientProvider>
  );
}
